import { Box, Button, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
const CancelButton = ({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) => {
  const theme = useTheme()
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('md'))
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {isExtraLargeScreen ? (
        <Button
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 42,
            borderColor: theme.palette.icon.decline,
            zIndex: 20,
            '&:hover': {
              opacity: '10%',
            },
          }}
          // disabled={isRequesting || isRequested || !isValid}
          disabled={disabled}
          onClick={onClick}
          name="cancel-contract-button"
          variant="outlined"
          color="primary"
        >
          <Typography>Cancel</Typography>
        </Button>
      ) : (
        <Tooltip title={<Typography>Cancel</Typography>}>
          <div>
            <Button
              onClick={onClick}
              disabled={disabled}
              size={'medium'}
              sx={{
                border: !disabled ? `1px solid ${theme.palette.icon.decline}` : '',
                '&:hover': {
                  borderColor: theme.palette.text.highlight,
                },
              }}
            >
              <Typography>Cancel</Typography>
            </Button>
          </div>
        </Tooltip>
      )}
    </Box>
  )
}

export default CancelButton
